import { getDefaultHttpApiUrl } from '../net/network';

export const AUTH_SESSION_STORAGE_KEY = 'dalworld:session-token';
export const AUTH_USERNAME_STORAGE_KEY = 'dalworld:last-username';

export function loadSessionToken(): string | null {
  try {
    return window.localStorage.getItem(AUTH_SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function saveSessionToken(token: string): void {
  try {
    window.localStorage.setItem(AUTH_SESSION_STORAGE_KEY, token);
  } catch {
    // localStorage may be unavailable.
  }
}

export function clearSessionToken(): void {
  try {
    window.localStorage.removeItem(AUTH_SESSION_STORAGE_KEY);
  } catch {
    // localStorage may be unavailable.
  }
}

export function loadLastUsername(): string {
  try {
    return window.localStorage.getItem(AUTH_USERNAME_STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}

export function saveLastUsername(username: string): void {
  try {
    window.localStorage.setItem(AUTH_USERNAME_STORAGE_KEY, username);
  } catch {
    // localStorage may be unavailable.
  }
}

export function clearLastUsername(): void {
  try {
    window.localStorage.removeItem(AUTH_USERNAME_STORAGE_KEY);
  } catch {
    // localStorage may be unavailable.
  }
}

export function logoutAndReload(): void {
  const sessionToken = loadSessionToken();
  clearSessionToken();

  if (sessionToken) {
    void fetch(getDefaultHttpApiUrl('/auth/logout'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionToken }),
      keepalive: true,
    }).finally(() => {
      window.location.reload();
    });
    return;
  }

  window.location.reload();
}
